import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { HomeRoute } from '@/home/HomeRoute';

/**
 * Thin route-file shell. The screen component (HomeRoute + the
 * records-list + signed-out placeholder + helpers) lives at
 * `src/home/home-route.tsx`. This file owns only the route
 * registration and the search-param schema.
 *
 * See `apps/client/docs/design.md` §"Route files are thin shells".
 */

const STATUS_VALUES = ['new', 'incomplete', 'complete'] as const;

// `.catch(undefined)` keeps a malformed/unknown `?status=` value from
// throwing on entry — the route just falls back to "All" instead of
// 404ing the user. Cheap defensive layer; the URL is user-editable.
const indexSearchSchema = z.object({
  status: z.enum(STATUS_VALUES).optional().catch(undefined),
});

export const Route = createFileRoute('/')({
  component: HomeRoute,
  validateSearch: indexSearchSchema,
});
